module.exports = __webpack_public_path__ + "img/eye-show-visible.71d34fa2.svg";